import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import sectorsUK from "@/.sourceflow/sectors_uk.json";
import sectorsUS from "@/.sourceflow/sectors_us.json";

export const useJobSectors = ({ locale } = {}) => {
  const collection = useSourceFlowCollection(locale == "/us/" ? sectorsUS : sectorsUK);
  return collection;
};

export default useJobSectors;
